export default __webpack_public_path__ + "static/element_logo.inline-212987dcd806c7e074f54f84b42b5e7e.png";